import React, { Component } from 'react';
import { Link } from "react-router-dom"
import { Row, Spin, Icon, Button, Col, notification, Alert } from 'antd';
import { connect } from 'react-redux';
import { getCourses, getMyCourses } from '../../../../core/actions/courseGet';
import Course from '../../components/course/course';
import TopNav from '../../components/topnav/topnav';
import Footer from '../../components/footer/footer';
import Banner from '../../components/courses/banner'
import OurCourses from '../../components/courses/ourcourses'
import { Helmet } from "react-helmet";
import { getLastView } from '../../../../core/actions/courseGet';
import { bindActionCreators } from 'redux'
const openNotificationWithIcon = (type, msg, desc) => {
  notification[type]({
    message: msg,
    description: desc,
  });
};

class Courses extends Component {
  constructor(props) {
    super(props);

    this.state = {
      courses: [],
      sections: [],
      mycourses: [],
      lastViewCourse: {},
      showMyCourses: false
    };
  }

  componentWillMount() {
    if (window.location.search) {
      let query = window.location.search
      let URL = new URLSearchParams(query);
      let getShow = URL.get("show")
      if (getShow === 'mycourses') {
        if (this.props.profile.isEmpty) {
          this.props.history.push('/error')
        } else {
          this.setState({
            showMyCourses: true
          })
        }
      } else {
        this.props.history.push('/error')
      }
    }
  }

  componentDidMount() {
    window.fbq('track', 'ViewContent');
    const { courses, isAdmin, mycourses } = this.state;
    const { course } = this.props
    const uid = window.localStorage.getItem("uid")
    if (!mycourses.length && uid) {
      this.props.getMyCourses()
    }
    if (!courses.length) {
      this.props.getCourses();
      // this.props.getMyCourses(this.props.profile.coursespool)
      // console.log('get courses from store after cdm')
    }
    if (uid) {
      this.props.getLastView(uid)
    }

    if (course.deleteSuccess) {
      openNotificationWithIcon('success', 'Course Deleted!', course.deleteSuccess)
      this.props.getCourses();
      this.props.getMyCourses()
    }

    // console.log(profile)

  }

  componentWillReceiveProps(nextProps) {
    const { courses, sections, course, profile, mycourses, lastViewCourse } = nextProps;

    if (course.deleteSuccess) {
      openNotificationWithIcon('success', 'Course Deleted!', course.deleteSuccess)
    }
    if (courses.length > 0) {
      courses.sort((a, b) => new Date(b.created) - new Date(a.created))
      this.setState({ courses });
    }
    if (lastViewCourse.id) {
      this.setState({ lastViewCourse })
    }
    if (mycourses.length > 0) {
      this.setState({ mycourses });
    }
  }


  render() {
    const { courses, sections, mycourses, lastViewCourse } = this.state;
    const { firebase } = this.props;
    const loading = !courses.length > 0;
    const sendSection = (sections) => {
      sections.map(section => {
        return section
      })
    }
    return (
      courses.length ? <div className="courses-page">
        <Helmet>
          <title>Our Courses</title>
          <meta name="description" content="You won't find boring 8 hour courses on orsity, instead you'll find a wealth of bite-sized courses that pack more information in a fraction of the time." />
        </Helmet>

        <TopNav history={this.props.history} />

        {/* <Banner /> */}
        {/* <br /> <br /` > <br /> */}
        {lastViewCourse.id ?
          <Alert
            closable
            message="Pickup where you left off"
            description={<div style={{ display: "flex", flex: 1, justifyContent: "space-between", paddingRight: '10px' }}>
              <div>
                {lastViewCourse.title}
              </div>
              {window.innerWidth > 760 ? <Link to={`/courses/${lastViewCourse.slug}/lectures`}>Click to continue</Link> : null}
            </div>}
            type="info"
            showIcon
          /> : null}
        <OurCourses
          courses={courses}
          mycourses={mycourses}
          firebase={this.props.firebase}
          showMyCourses={this.state.showMyCourses}
          lastViewCourse={lastViewCourse}
          getFilteredCourse={this.props.getFilteredCourse}
        />

        <Footer />


      </div> : <div className="x-loader">
          <Icon type="loading" style={{ fontSize: 60 }} spin />
        </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  getCourses,
  getMyCourses,
  getLastView
}, dispatch);
const mapStateToProps = state => ({
  firebase: state.firebase,
  courses: state.getCourses.courses,
  mycourses: state.getCourses.mycourses,
  course: state.course,
  lastViewCourse: state.getCourses.lastViewCourse,
  profile: state.firebase.profile
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Courses);
